module.exports = __webpack_public_path__ + "img/leverage.ca219570.png";